var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { BreadCrumbsWrapper, BreadCrumbWrapper, LastBreadCrumb, } from './styles';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { CaretIcon, BreadCrumb, } from '../../app-builder/BreadcrumbsAppBuilder/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../UI-helpers/colors';
var BreadCrumbs = function (_a) {
    var crumbs = _a.crumbs, onCrumbClick = _a.onCrumbClick;
    var navigate = useNavigate();
    var onCrumbClickAction = function (path) {
        navigate(path);
    };
    var onCrumbClickToUse = onCrumbClick !== null && onCrumbClick !== void 0 ? onCrumbClick : onCrumbClickAction;
    return (_jsx(BreadCrumbsWrapper, { children: crumbs.map(function (item, index) { return (_jsxs(BreadCrumbWrapper, __assign({ onClick: function () {
                onCrumbClickToUse && item.to && onCrumbClickToUse(item.to);
            } }, { children: [crumbs.length === 1 ? ( //Single breadcrumb
                _jsx(LastBreadCrumb, { children: item.text })) : (_jsx(_Fragment, { children: index === 0 ? ( //first breadcrumb
                    _jsx(BreadCrumb, { children: item.text })) : crumbs.length === index + 1 ? ( //last breadcrumb
                    _jsx(LastBreadCrumb, { children: item.text })) : (_jsx(BreadCrumb, { children: item.text }) //middle breadcrumb
                    ) })), crumbs.length !== index + 1 && (_jsx(CaretIcon, { children: _jsx(FontAwesomeIcon, { color: colors.inActive, style: { fontSize: 16 }, icon: faChevronRight }) }))] }), item.text)); }) }));
};
var mapDispatchToProps = function () { return ({}); };
export default connect(null, mapDispatchToProps)(BreadCrumbs);
